import { useState } from 'react';
import {
  Box,
  Fade,
  IconButton,
  Link,
  Popper,
  Typography,
  useTheme,
  ClickAwayListener,
} from '@mui/material';

import { Icon } from '@toolbox/components';

import type { PhoneCta } from '@widget/types/PhoneCtaType';
import type { FC } from 'react';

export const PhoneCTA: FC<{ phoneCTA: PhoneCta }> = ({ phoneCTA }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openPhoneDropdown = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const closePhoneDropdown = (): void => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        disableRipple
        aria-label="show phone"
        aria-expanded={Boolean(anchorEl)}
        onClick={openPhoneDropdown}
        sx={{ margin: '0 0 0 8px' }}
      >
        <Icon size={'inherit'} type="PhoneFilled" htmlColor={theme.palette.primary.main} />
      </IconButton>
      <Popper
        id="phone-dropdown"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        transition
        placement="bottom-end"
        style={{ zIndex: 9999 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Box
              display="flex"
              flexDirection="column"
              bgcolor="white"
              boxShadow="0px 2px 8px rgb(0 0 0 / 12%)"
              py={2}
              px={2}
              textAlign="center"
            >
              <ClickAwayListener onClickAway={closePhoneDropdown}>
                <div>
                  <Typography noWrap={true} color={'primary'}>
                    {phoneCTA.text}
                  </Typography>
                  <Link
                    href={`tel:${phoneCTA.target}`}
                    underline="none"
                    sx={{
                      bgcolor: 'white',
                      border: 'none',
                      '&:hover': {
                        bgcolor: 'white',
                        border: 'none',
                      },
                    }}
                  >
                    <b>{phoneCTA.tel}</b>
                  </Link>
                </div>
              </ClickAwayListener>
            </Box>
          </Fade>
        )}
      </Popper>
    </>
  );
};
